import { defineComponent as _defineComponent } from 'vue'
import { toRefs, watch, ref } from '@nuxtjs/composition-api';

interface Props {
    trigger?: 'click' | 'hover' | 'focus' | 'manual';
    placement?: 'top' | 'top-start' | 'top-end' | 'bottom' | 'bottom-start' | 'bottom-end' | 'left' | 'left-start' | 'left-end' | 'right' | 'right-start' | 'right-end';
    width?: string | number;
    title?: string;
    content?: string;
    disabled?: boolean;
    offset?: number | string;
    transition?: string;
    visibleArrow?: boolean;
    popperClass?: string;
    openDelay?: number;
    closeDelay?: number;
    tabindex?: number;
    popperOptions?: object;
    value?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Simple',
  props: {
    trigger: { default: 'click' },
    placement: { default: 'bottom' },
    width: null,
    title: null,
    content: null,
    disabled: { type: Boolean, default: false },
    offset: null,
    transition: null,
    visibleArrow: { type: Boolean, default: false },
    popperClass: { default: '' },
    openDelay: null,
    closeDelay: null,
    tabindex: null,
    popperOptions: null,
    value: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'input', value: boolean): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { trigger: 'click' | 'hover' | 'focus' | 'manual', placement: 'top' | 'top-start' | 'top-end' | 'bottom' | 'bottom-start' | 'bottom-end' | 'left' | 'left-start' | 'left-end' | 'right' | 'right-start' | 'right-end', width?: string | number, title?: string, content?: string, disabled: boolean, offset?: number | string, transition?: string, visibleArrow: boolean, popperClass: string, openDelay?: number, closeDelay?: number, tabindex?: number, popperOptions?: object, value: boolean };





const {
    trigger,
    placement,
    width,
    title,
    content,
    disabled,
    offset,
    transition,
    visibleArrow,
    popperClass,
    openDelay,
    closeDelay,
    tabindex,
    popperOptions,
    value,
} = toRefs(props);

const isOpen = ref(false);

watch(value, (newValue) => {
    isOpen.value = newValue;
});

const onChange = (value) => {
    emit('input', value);
    isOpen.value = value;
};


return { __sfc: true,props, emit, trigger, placement, width, title, content, disabled, offset, transition, visibleArrow, popperClass, openDelay, closeDelay, tabindex, popperOptions, value, isOpen, onChange }
}

})